import { createActions } from '../utils/actions';

const { actions: shops } = createActions('shops')
  .addAsync('getShops')
  .addAsync('refreshUserInitiatedShop')
  .addAsync('refreshUserShop')
  .add('rescheduleShopsPolling')
  .add('setData')
  .addAsync('validateOauthToken');

export default shops;
